<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.balanceRecords'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />

    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              type="primary"
              size="mini"
              :loading="batchVerifyDoing"
              @click="batchVerifyPass"
              >{{ $t("verifyInfos.agree") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :loading="loading"
        id="balancesTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          min-width="140"
        />
        <vxe-table-column
          field="payMethodName"
          :title="$t('balance.payMethod')"
          min-width="60"
        />
        <vxe-table-column field="fee" :title="$t('balance.fee')" min-width="70">
          <template v-slot="{ row }">
            <span :class="row.type == 'in' ? 'green' : 'red'">{{
              row.fee | currency
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="voucher"
          :title="$t('payment.voucher')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <thumbnail-text :srcs="row.voucher" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="10" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="operator"
          :title="$t('balance.operator')"
          min-width="60"
        />
        <vxe-table-column
          field="createdAt"
          :title="$t('text.createAt')"
          min-width="110"
        />

        <vxe-table-column
          field="dealType"
          :title="$t('verify.dealType')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <span
              v-if="row.balanceAudit != null"
              :class="
                row.balanceAudit.dealType == 'agree' ? 'green-shallow' : 'red'
              "
              >{{ $t("verifyInfos." + row.balanceAudit.dealType) }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="commentAt"
          :title="$t('verify.commentAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <span v-if="row.balanceAudit != null">{{
              row.balanceAudit.commentAt
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="commentName"
          :title="$t('verify.commentName')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <span v-if="row.balanceAudit != null">{{
              row.balanceAudit.commentName
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="comment"
          :title="$t('verify.comment')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              v-if="row.balanceAudit != null"
              :content="row.balanceAudit.comment"
              :number="10"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="50">
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="row.balanceAudit == null"
              type="text"
              size="mini"
              @click="verifyReject(row, rowIndex)"
              >{{ $t("action.reject") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('action.reject')"
      :close-on-click-modal="false"
      :visible.sync="verifyRejectDF"
      width="30%"
    >
      <el-form ref="verifyRejectForm" :model="verifyRejectObj">
        <el-form-item :prop="'comment'">
          <el-input
            size="small"
            v-model.trim="verifyRejectObj.comment"
            type="textarea"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="verifyRejectDoing"
          size="small"
          @click="verifyRejectSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="verifyRejectDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import ThumbnailText from "@/components/ThumbnailText";
import BalanceInOut from "@/api/balanceInOut.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    ThumbnailText,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      Util: Util,
      narrows: [
        [
          {
            label: this.$t("verify.dealType"),
            items: [
              {
                label: this.$t("verifyInfos.agree"),
                key: "agree",
                condition: { balanceVerify: "agree" },
              },
              {
                label: this.$t("verifyInfos.reject"),
                key: "reject",
                condition: { balanceVerify: "reject" },
              },
              {
                label: this.$t("verifyInfos.no"),
                key: "no",
                condition: { balanceVerify: "no" },
              },
            ],
          },
        ],
      ],
      sorter: {
        sortBy: "balanceInOuts_id",
        sortIndicator: "desc",
      },
      initFilter: "no",
      //
      batchVerifyDoing: false,
      //
      row: null,
      verifyRejectDF: false,
      verifyRejectObj: {
        comment: null,
      },
      verifyRejectDoing: false,
    };
  },

  computed: {
    implicit() {
      return {
        type: "in",
        manualCharge: "yes",
      };
    },
  },
  created() {
    const self = this;
  },
  methods: {
    // 审核拒绝
    verifyReject(row) {
      const self = this;
      self.row = row;
      self.verifyRejectObj.comment = null;
      self.verifyRejectDoing = false;
      self.verifyRejectDF = true;
    },
    verifyRejectSubmit() {
      const self = this;
      self.verifyRejectDoing = true;
      BalanceInOut.balanceVerifyReject(self.row.id, self.verifyRejectObj).then(
        function (res) {
          if (res.status == 200) {
            self.verifyRejectDoing = false;
            self.verifyRejectDF = false;
            self.$message({
              message: self.$t("prompt.rejectSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        }
      );
    },
    //
    batchVerifyPass() {
      const self = this;
      if (self.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const datas = self.selectRecords.map((c) => {
        return {
          entityId: c.id,
        };
      });
      self.batchVerifyDoing = true;
      BalanceInOut.batchBalanceVerify(datas).then(function (res) {
        self.batchVerifyDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 可选
    checCheckboxMethod({ row }) {
      if (
        row.balanceAudit == null ||
        (row.balanceAudit != null && row.balanceAudit.dealType === "reject")
      ) {
        return true;
      }
      return false;
    },

    //-----
    dataProvider(params) {
      return BalanceInOut.search(params);
    },
  },
};
</script>
